<template>
  <NotificationTemplate
    :notification="notification"
    class="notification__item"
  >
    <template #pic>
      <div class="label-pic is-red">
        <icon
          data="@icon/timesheets.svg"
          class="label-pic__icon"
          width="var(--icon-24)"
          height="var(--icon-24)"
        />
      </div>
    </template>
    <template #title>
      <BaseSubHeading
        size="large"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="500"
      >
        Timesheet Declined
      </BaseSubHeading>
    </template>
    <template #content>
      <BaseSubHeading
        size="medium"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="500"
      >
        by <span class="link is-medium">@{{ notification.initiator.fullName }}</span> ({{
          notification.startDate
        }}
        - {{ notification.endDate }}):
      </BaseSubHeading>
      <BaseSubHeading
        size="medium"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="400"
      >
        {{ notification.declineReason }}
      </BaseSubHeading>
    </template>
  </NotificationTemplate>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"

import NotificationTemplate from "@/components/Notification/NotificationTemplate.vue"

import { NotificationTimesheet } from "@/models/Notification"

@Options({
  name: "TIMESHEET_DECLINED",
  components: {
    NotificationTemplate
  }
})
export default class TIMESHEET_DECLINED extends Vue {
  @Prop() readonly notification: NotificationTimesheet
}
</script>
